<template lang="html">

  <div class="animated fadeIn">
    <b-card>
      <b-button-toolbar class="pull-right">
        <b-btn variant="primary" @click="showAddPerson">Add Vaccination Entry</b-btn>
      </b-button-toolbar>
    </b-card>
    <b-card>
      <b-row>
        <b-col lg="6" class="my-1">
          <b-form-group label="Filter"
                        label-align-sm="left"
                        label-size="lg"
                        label-for="filterInput"
                        class="mb-0">
            <b-input-group size="sm">
              <b-form-input v-model="filter"
                            type="search"
                            id="filterInput"
                            placeholder="Type to Search"></b-form-input>
              <b-input-group-append>
                <b-button :disabled="!filter" @click="filter = ''">Clear</b-button>
              </b-input-group-append>
            </b-input-group>
          </b-form-group>
        </b-col>
        <b-col lg="6" class="my-1">
          <b-form-group label="Sort"
                        label-align-sm="left"
                        label-size="lg"
                        label-for="sortBySelect"
                        class="mb-0">
            <b-input-group size="sm">
              <b-form-select v-model="sortBy" id="sortBySelect" :options="sortOptions" class="w-75">
                <template #first>
                 <option value="">-- none --</option>
               </template>
              </b-form-select>
              <b-form-select v-model="sortDesc" size="sm" :disabled="!sortBy" class="w-25">
                <option :value="false">Asc</option>
                <option :value="true">Desc</option>
              </b-form-select>
            </b-input-group>
          </b-form-group>
        </b-col>

      </b-row>
      <hr/>
      <b-row>
        <b-col>
          <b-table hover
                   :busy="isBusy"
                   :sort-by.sync="sortBy"
                   :sort-desc.sync="sortDesc"
                   :filter="filter"
                   @filtered="onFiltered"
                   :current-page="currentPage"
                   :per-page="perPage"
                   :items="personList"
                   :fields="fields"
                   id="dataTable"
                   ref="dataTable"
                   responsive="sm">
            <template #table-busy>
                 <div class="text-center text-danger my-2">
                   <b-spinner class="align-middle"></b-spinner>
                   <strong>Loading...</strong>
                 </div>
              </template>
            <template v-slot:cell(name)="row">
                <b>{{ row.value}}</b>
              </template>
            <template v-slot:cell(show_details)="row">
                  <b-button size="sm" @click="showVacTypes(row)" class="mr-2">
                    {{ row.detailsShowing ? 'Hide' : 'Show'}} Vaccinations
                  </b-button>
              </template>
            <template v-slot:cell(actions)="row">
                    <b-btn size="sm" variant="outline-primary" @click="showEditPerson(row)" class="mr-1">Edit</b-btn>
                    <b-btn size="sm" variant="outline-success" @click="printPersonCard(row)" class="mr-1">Print Card</b-btn>
              </template>
            <template v-slot:row-details="row">
                 <b-table table-variant="info" striped  :fields="detailsFields" :items="row.item.personVac"></b-table>
                 <b-button size="sm" @click="row.toggleDetails">Hide Vaccination</b-button>
              </template>

          </b-table>
        </b-col>
      </b-row>
      <b-row>
        <b-col v-if="personList!=null && Object.keys(personList).length > 0 && this.isBusy == false" class="text-center">
          <b-pagination v-model="currentPage"
                        :total-rows="totalRows"
                        :per-page="perPage"
                        align="fill"
                        class="my-0">
          </b-pagination>
        </b-col>
      </b-row>
    </b-card>
    <div>
      <b-modal scrollable
               size="lg"
               hide-footer
               no-close-on-backdrop
               no-close-on-esc
               ref="modalEditPerson"
               title="Edit Person Details"
               hide-footer
               @hide="hideEditPerson">
        <person-edit v-if="selectedPerson" :selectedPerson="selectedPerson" @success="editPersonSuccess" @cancel="cancelEditPerson"
        />
      </b-modal>
    </div>
    <div>
      <b-modal scrollable
               size="lg"
               hide-footer
               no-close-on-backdrop
               no-close-on-esc
               ref="modalAddPerson"
               title="Add Vaccination Entry"
               hide-footer>
        <person-add @success="addPersonSuccess" @cancel="cancelAddPerson" />
      </b-modal>
    </div>
    <div id="vCardList" style="display:none;">
      <vaccination-print-card ref="vacPrintCardList"></vaccination-print-card>
    </div>
  </div>

</template>
<script>

  import { mapState, mapActions } from 'vuex'
  import Vue from 'vue'
  import PersonEdit from './VimsEditPerson'
  import PersonAdd from './VimsEntryForm'
  import VaccinationPrintCard from './VaccinationPrintCard'
  export default {
    name: 'VimsPersonList',
    components: {
      PersonEdit,
      PersonAdd,
      VaccinationPrintCard
    },

    data: function() {
      return {
        totalRows: 1,
        sortBy: '',
        currentPage: 1,
        sortDesc: false,
        perPage: 50,
        filter: null,
        isBusy: false,
        personVac: null,
        personList: [],
        selectedPerson: null,
        fields: [
          { key: 'name', label: 'Name', sortable: true, sortDirection: 'desc' },
          { key: 'mobile', label: 'Mobile No' },
          { key: 'address', label: 'Address' },
          { key: 'doses', label: 'No of Doses', sortable: true, sortDirection: 'desc' },
          { key: 'show_details', label: 'Vaccine Information' },
          { key: 'actions', label: 'Actions' }
        ],
        detailsFields: [
          { key: 'dose', label: 'Dose Number' },
          { key: 'vtype', label: 'Vaccine Name' },
          { key: 'date', label: 'Date' }
        ],
        useVuex: false,
        theme: 'bootstrap4',
        template: 'default'
      }
    },
    computed: {
      persons() {
        return this.personList
      },
      sortOptions() {
        return this.fields
          .filter(f => f.sortable)
          .map(f => {
            return { text: f.label, value: f.key }
          })
      }
    },
    methods: {
      showAddPerson() {
        this.$refs.modalAddPerson.show()
      },
      cancelAddPerson() {
        this.$refs.modalAddPerson.hide()
      },
      addPersonSuccess() {
        this.$refs.modalAddPerson.hide()
        this.getPersonList()
      },
      printPersonCard(row) {
        this.$nextTick(() => {
          let params = {
            id: row.item.id
          }
          this.$store
            .dispatch('vims/getPersonCardInfo', params)
            .then(response => {
              if (response.data.success == false) {
                this.showErrorMsg({
                  message: response.data.error
                })
              } else {
                this.showPrintCard = false
                this.setVacCardData(response.data.data)
                this.showSuccessMsg({
                  message: 'Printing Job sent successfully.'
                })
              }
            })
            .catch(error => {
              if (error.response.status == 400) {
                this.showErrorMsg({
                  message: error.response.data.message
                })
              } else if (error.response.status == 422) {
                this.showErrorMsg({
                  message: error.response.data.message
                })
              } else {
                this.showErrorMsg({
                  message: 'Something went when wrong while printing card. Please contact administrator.'
                })
              }
            })
        })
      },
      async setVacCardData(data) {
        let person = []
        let doses = []
        person['srNo'] = data.srNo
        person['name'] = data.name
        person['mobile'] = data.mobile
        person['cardNo'] = data.cardNo
        person['address'] = data.address
        doses = data.doses
        this.$refs.vacPrintCardList.setCardData(person, doses)
        await this.sleep(1000)
        this.$htmlToPaper('vCardList')
      },

      sleep(ms) {
        return new Promise(resolve => {
          setTimeout(resolve, ms)
        })
      },
      getPersonList() {
        this.isBusy = true
        this.$nextTick(() => {
          this.$store
            .dispatch('vims/getPersons')
            .then(response => {
              this.personList = response.data.data
              this.totalRows = this.personList.length
              this.isBusy = false
            })
            .catch(error => {
              if (error.response.status == 400) {
                this.showErrorMsg({
                  message: error.response.data.message
                })
              } else if (error.response.status == 422) {
                this.showErrorMsg({
                  message: error.response.data.message
                })
              } else {
                this.showErrorMsg({ message: 'Something went wrong. Please contact administrator.' })
              }
              this.isBusy = false
            })
        })
      },
      showEditPerson(row) {
        if (this.$store.state.vims.vaccineTypes.length == 0) {
          this.$store.dispatch('vims/getVaccineTypes')
        }

        this.selectedPerson = row.item
        this.$refs.modalEditPerson.show()
      },
      cancelEditPerson() {
        this.$refs.modalEditPerson.hide()
      },

      editPersonSuccess() {
        this.$refs.modalEditPerson.hide()
        this.getPersonList()
      },
      hideEditPerson() {
        this.selectedPerson = null
      },
      showVacTypes(row) {
        this.$nextTick(() => {
          let params = {
            id: row.item.id
          }
          this.$store
            .dispatch('vims/getPersonVacs', params)
            .then(response => {
              if (response.data.success == false) {
                this.showErrorMsg({
                  message: response.data.error
                })
              } else {
                row.item.personVac = response.data.data
                row.toggleDetails()
              }
            })
            .catch(error => {
              if (error.response.status == 400) {
                this.showErrorMsg({
                  message: error.response.data.message
                })
              } else if (error.response.status == 422) {
                this.showErrorMsg({
                  message: error.response.data.message
                })
              } else {
                this.showErrorMsg({
                  message:
                    'Something went when wrong getting Person Vaccination information. Please contact administrator.'
                })
              }
            })
        })
      },
      onFiltered(filteredItems) {
        this.totalRows = filteredItems.length
        this.currentPage = 1
      }
    },
    created() {
      if (this.personList.length == 0) {
        this.getPersonList()
      }
    }
  }

</script>
